import { Navigate, useLocation } from '@modern-js/runtime/router';
import { useContext, useEffect, useState } from 'react';
import { Dropdown, Avatar } from '@arco-design/web-react';

import GlobalStore from '@store/globalStore';
import { useModel } from '@modern-js/runtime/model';
import { useCookieState } from 'ahooks';
import { fetchUserInfo } from '@api/copilot_api';
import { GlobalContext } from './context';
import UserDropdown from '@/components/user-dropdown';
import useUrlParams from '@/hooks/useUrlParams';
import { AUTH_STATUS_KEY, AuthorizationStatus } from '@/config/constant';

export const UserAuthProvider = ({ children }: { children: JSX.Element }) => {
  const { resetToken = '' } = useUrlParams();
  const location = useLocation();
  const { setUserInfo } = useContext(GlobalContext);
  const [, actions] = useModel(GlobalStore);
  const [, setMessage] = useCookieState(AUTH_STATUS_KEY);

  useEffect(() => {
    const isPasswordExpired = localStorage.getItem('PASSWORD_EXPIRED') === '1';
    const isPwdResetPath = location.pathname.includes('/pwd/reset');
    const isLoginPath = location.pathname.includes('/login');
    const isPwdPath = location.pathname.includes('/pwd');
    const isRegPath = location.pathname.includes('/reg');
    const isInvitePath = location.pathname.includes('/invite');

    // 如果密码过期且不在密码重置页面和登录页，清除授权并跳转登录页
    if (isPasswordExpired && !isLoginPath && !isPwdPath && !isRegPath && !isInvitePath) {
      localStorage.removeItem('PASSWORD_EXPIRED');
      localStorage.clear();
      sessionStorage.clear();
      setMessage(AuthorizationStatus.Authenticated);
      window.location.replace('/login');
      return;
    }

    // 获取用户信息
    if ((!isPwdPath || isPwdResetPath) && !isRegPath && !isInvitePath && !resetToken) {
      getUser();
    }
  }, [location.pathname, resetToken]);

  const getUser = async () => {
    try {
      const { userInfo = {}, meetingOnlyUser } = await fetchUserInfo({});
      setUserInfo?.({ userUniqueId: userInfo.accountId, userId: userInfo.accountId, meetingOnlyUser });
      actions.setUser({ ...userInfo, meetingOnlyUser });
      localStorage.setItem('userInfo', JSON.stringify(userInfo || {}));
    } catch (error: any) {
      console.log('error---->', error);
    }
  };

  return children;
};

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();

  const [message] = useCookieState(AUTH_STATUS_KEY);

  if (!Number(message)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export const AuthUserInfo = () => {
  const [{ userInfo = {} }] = useModel(GlobalStore);
  const [visible, setVisible] = useState(false);

  return (
    <>
      {userInfo?.accountId ? (
        <Dropdown
          droplist={<UserDropdown />}
          popupVisible={visible}
          onVisibleChange={visible => {
            setVisible(visible);
          }}
          position="br"
          trigger="click"
        >
          <div className="flex items-center cursor-pointer select-none text-base ">
            <Avatar autoFixFontSize style={{ backgroundColor: '#6585fa' }} size={28}>
              {userInfo?.screenName?.substring(0, 1)}
            </Avatar>
          </div>
        </Dropdown>
      ) : (
        <></>
      )}
    </>
  );
};
